import { UserManager, WebStorageStateStore } from "oidc-client-ts";

let manager = null;

function getConfig() {
  return window.App?.oidc || {};
}

function isEnabled() {
  const config = getConfig();
  return Boolean(config.enabled && config.clientId);
}

function getManager() {
  if (!isEnabled()) {
    throw new Error("OpenID Connect is not configured.");
  }

  if (!manager) {
    const config = getConfig();

    manager = new UserManager({
      authority: config.authority,
      client_id: config.clientId,
      redirect_uri: config.redirectUri,
      post_logout_redirect_uri: config.postLogoutRedirectUri,
      response_type: "code",
      scope: config.scope || "openid profile email",
      loadUserInfo: true,
      monitorSession: false,
      automaticSilentRenew: false,
      userStore: new WebStorageStateStore({
        store: window.localStorage
      })
    });
  }

  return manager;
}

export default {
  isEnabled,

  async signinRedirect() {
    return getManager().signinRedirect();
  },

  async signinRedirectCallback() {
    return getManager().signinRedirectCallback();
  },

  async getUser() {
    if (!isEnabled()) {
      return null;
    }

    return getManager().getUser();
  },

  async getAccessToken() {
    const user = await this.getUser();
    return user && !user.expired ? user.access_token : null;
  },

  async removeUser() {
    if (isEnabled()) {
      await getManager().removeUser();
    }
  }
};
